import LazyLoad from 'vanilla-lazyload';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

window.imageLazyLoad = new LazyLoad({
  elements_selector: '.image-lazy',
  unobserve_entered: true,
});

document.addEventListener('lazybeforeunveil', (e) => {
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  let bg;
  if (isMobile && e.target.hasAttribute('data-bg-mobile')) {
    bg = e.target.getAttribute('data-bg-mobile');
  } else {
    bg = e.target.getAttribute('data-bg-desktop');
  }
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});
